import { useRef, useState } from "react";
import { registerLocale } from "react-datepicker";
import { useTranslation } from "react-i18next";
import ReactDatePicker from "react-datepicker";
import CustomIcon from "../CustomIcon/CustomIcon";
import it from "date-fns/locale/it";
import styles from "./CustomPicker.module.css";

const CustomPicker: React.FC<any> = ({
  colorArrow = "#505050",
  isError = false,
  className,
  selected,
  ...props
}) => {
  const pickerRef = useRef<null | any>(null);
  const { t, i18n } = useTranslation();
  const lang = i18n.language;
  const [isOpen, setIsOpen] = useState(false);

  if (lang === "it") registerLocale("it", it);

  const handleKeyDown = (e: React.KeyboardEvent<HTMLDivElement>) => {
    if ((e.key === "Enter" || e.key === " ") && !isOpen) {
      e.preventDefault();
      setIsOpen(true);

      // Sposta focus sulla data selezionata o sulla prima disponibile
      setTimeout(() => {
        const selectedDay = document.querySelector<HTMLDivElement>(
          ".react-datepicker__day--selected"
        );
        const firstDay = document.querySelector<HTMLDivElement>(
          ".react-datepicker__day"
        );
        if (selectedDay) {
          selectedDay.focus();
        } else if (firstDay) {
          firstDay.focus();
        }
      }, 100);
    }

    if (e.key === "Escape" && isOpen) {
      e.preventDefault();
      setIsOpen(false);
    }
  };

  const formattedDate = selected
    ? new Date().toDateString() === new Date(selected).toDateString()
      ? t("parking.today")
      : new Date(selected).toLocaleDateString()
    : t("parking.date");

  return (
    <div className="h-full w-full" onClick={(e) => e.stopPropagation()}>
      <div
        role="button"
        tabIndex={0}
        aria-label={(t("parking.date") ?? "").toString()}
        onClick={() => {
          setIsOpen(true);
          setTimeout(() => {
            const selectedDay = document.querySelector<HTMLDivElement>(
              ".react-datepicker__day--selected"
            );
            const firstDay = document.querySelector<HTMLDivElement>(
              ".react-datepicker__day"
            );
            if (selectedDay) {
              selectedDay.focus();
            } else if (firstDay) {
              firstDay.focus();
            }
          }, 100);
        }}
        onKeyDown={handleKeyDown}
        className={`bg-white py-3 desk:px-6 px-4 w-[135px] desk:w-full h-full cursor-pointer rounded-2xl desk:rounded-l-2xl ${
          isError ? "border border-red" : ""
        } flex gap-4 items-center justify-between focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500`}
      >
        <div>{formattedDate}</div>
        <CustomIcon
          className={`w-2 transition-transform origin-center duration-300 ${
            isOpen ? "rotate-90" : "rotate-0"
          }`}
          iconName="chevron-r"
          color={colorArrow}
        />
      </div>

      <div className="overwritedPickerContainer">
        <ReactDatePicker
          ref={pickerRef}
          locale={lang === "it" ? "it" : ""}
          {...props}
          selected={selected}
          open={isOpen}
          onClickOutside={() => setIsOpen(false)}
          onSelect={() => setIsOpen(false)}
          className={`${className} ${styles.reactDatePicker}`}
        />
      </div>
    </div>
  );
};

export default CustomPicker;
